import { Box } from '@mui/material';
import useWidth from '../../../../../../components/Hooks/useWidth';
import { MediaFormatEnum } from '../../../../../general-settings/enums/mediaFormat.enum';
import useSelectedMediaIndex from '../../hooks/useSelectedMediaIndex';
import { ProductGalleryProps } from '../../interfaces/productGallery.interfaces';
import { useGalleryLayoutStyles } from '../../styles/gallery.styles';
import GalleryMainMedia from '../GalleryMainMedia/GalleryMainMedia';
import GalleryThumbStrip from '../GalleryThumbStrip/GalleryThumbStrip';
import SquareGalleryStack from './components/SquareGalleryStack/SquareGalleryStack';
import {
  SQUARE_ASPECT_RATIO,
  getSquareGalleryColumnWidth,
  getSquareThumbLayout,
} from './squareGallery.utils';

const GRID_FIT_TOLERANCE = 1;

const SquareGallery = ({
  medias,
  galleryWidth,
  galleryHeight,
  onZoom,
  onMobileContainerCover,
}: ProductGalleryProps) => {
  const { largeWidthUp } = useWidth();
  const { selectedIndex, setSelectedIndex } = useSelectedMediaIndex(medias);

  const hasRoomForThumbGrid =
    galleryWidth + GRID_FIT_TOLERANCE >= getSquareGalleryColumnWidth(galleryHeight);
  const isStackLayout = largeWidthUp && !hasRoomForThumbGrid;
  const { thumbWidth, thumbHeight, thumbRows, thumbColumns, maxThumbs } = getSquareThumbLayout({
    galleryWidth,
    galleryHeight,
  });

  const { classes } = useGalleryLayoutStyles({
    aspectRatio: SQUARE_ASPECT_RATIO,
    hasFixedMainMedia: true,
  });

  const mediaIndexes = medias.map((_, index) => index);
  const thumbIndexes = largeWidthUp
    ? mediaIndexes.filter((index) => index !== selectedIndex).slice(0, maxThumbs)
    : mediaIndexes;

  if (isStackLayout) {
    return <SquareGalleryStack medias={medias} onZoom={onZoom} />;
  }

  return (
    <Box className={classes.root}>
      <GalleryMainMedia
        medias={medias}
        selectedIndex={selectedIndex}
        className={classes.mainMediaBox}
        dotsClassName={classes.mediaDotsIndicator}
        onMobileContainerCover={onMobileContainerCover}
        onSelectIndex={setSelectedIndex}
        onZoom={onZoom}
      />

      <GalleryThumbStrip
        medias={medias}
        mediaFormat={MediaFormatEnum.SQUARE}
        thumbIndexes={thumbIndexes}
        thumbWidth={thumbWidth}
        thumbHeight={thumbHeight}
        thumbRows={thumbRows}
        thumbColumns={thumbColumns}
        maxThumbs={maxThumbs}
        isScrollable={false}
        selectedIndex={selectedIndex}
        onZoom={onZoom}
        onSelect={setSelectedIndex}
      />
    </Box>
  );
};

export default SquareGallery;
